/**
 * Browser-only persistence for drafts, approved snapshot, and generated artifacts.
 * No backend — replace with API calls later.
 */

const K = {
  DRAFT_MAP: "coding_assistant_draft_map",
  APPROVED_MAP: "coding_assistant_approved_map_snapshot",
  GENERATED_CODE: "coding_assistant_generated_code",
  GENERATED_CODE: "coding_assistant_generated_code",
  VALIDATION_HISTORY: "coding_assistant_validation_history",
  OWNER: "coding_assistant_owner",
  GUEST_TRIAL_HISTORY: "coding_assistant_guest_trial_history",
};

function safeParse(json, fallback) {
  try {
    return JSON.parse(json);
  } catch {
    return fallback;
  }
}

export function saveDraftMap(jsonText) {
  localStorage.setItem(K.DRAFT_MAP, jsonText);
}

export function loadDraftMap() {
  return localStorage.getItem(K.DRAFT_MAP);
}

export function clearDraftMap() {
  localStorage.removeItem(K.DRAFT_MAP);
}

export function saveApprovedSnapshot(payload) {
  localStorage.setItem(K.APPROVED_MAP, JSON.stringify(payload));
}

export function loadApprovedSnapshot() {
  const raw = localStorage.getItem(K.APPROVED_MAP);
  return raw ? safeParse(raw, null) : null;
}

export function clearApprovedSnapshot() {
  localStorage.removeItem(K.APPROVED_MAP);
}

export function saveGeneratedCode(payload) {
  localStorage.setItem(K.GENERATED_CODE, JSON.stringify(payload));
}

export function loadGeneratedCode() {
  const raw = localStorage.getItem(K.GENERATED_CODE);
  return raw ? safeParse(raw, null) : null;
}

export function clearGeneratedCode() {
  localStorage.removeItem(K.GENERATED_CODE);
}

export function appendValidationHistory(entry) {
  const raw = localStorage.getItem(K.VALIDATION_HISTORY);
  const list = raw ? safeParse(raw, []) : [];
  const next = [{ ...entry, at: new Date().toISOString() }, ...list].slice(0, 20);
  localStorage.setItem(K.VALIDATION_HISTORY, JSON.stringify(next));
  return next;
}

export function loadValidationHistory() {
  const raw = localStorage.getItem(K.VALIDATION_HISTORY);
  return raw ? safeParse(raw, []) : [];
}

export function clearAllLocalWorkflow() {
  clearDraftMap();
  clearApprovedSnapshot();
  clearGeneratedCode();
  localStorage.removeItem(K.VALIDATION_HISTORY);
  localStorage.removeItem(K.OWNER);
}

/**
 * Bind the locally-persisted workflow (draft/snapshot/generated code/history)
 * to a specific user. If the stored owner differs from the user logging in,
 * wipe everything so one account never sees another account's work.
 * Call this right after a successful login/registration.
 */
export function setWorkflowOwner(userKey) {
  const current = localStorage.getItem(K.OWNER);
  if (current !== userKey) {
    clearAllLocalWorkflow();
    localStorage.setItem(K.OWNER, userKey || "");
  }
}

export function getGuestTrialStatus() {
  const raw = localStorage.getItem(K.GUEST_TRIAL_HISTORY);
  let history = raw ? safeParse(raw, []) : [];
  
  // Filter out timestamps older than 30 days
  const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
  history = history.filter(timestamp => timestamp > thirtyDaysAgo);
  
  // Save cleaned history back
  localStorage.setItem(K.GUEST_TRIAL_HISTORY, JSON.stringify(history));
  
  return {
    attemptsUsed: history.length,
    attemptsLeft: Math.max(0, 3 - history.length),
    canGenerate: history.length < 3
  };
}

export function recordGuestTrialAttempt() {
  const raw = localStorage.getItem(K.GUEST_TRIAL_HISTORY);
  let history = raw ? safeParse(raw, []) : [];
  
  // Filter out timestamps older than 30 days
  const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
  history = history.filter(timestamp => timestamp > thirtyDaysAgo);
  
  history.push(Date.now());
  localStorage.setItem(K.GUEST_TRIAL_HISTORY, JSON.stringify(history));
}
